// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Window from '../_raw/ui/icon_window.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Window);
